module.exports = __webpack_public_path__ + "static/media/our-story.76e40ea4.jpg";